import { EnterpriseEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getEnterpriseToken = async (expiryDays: number): Promise<any> =>
  APIManager.sendPost(
    EnterpriseEnds.GET_ENTERPRISE_TOKEN(expiryDays),
    {},
    true,
    {},
    {},
    axios
  );

const getTokenList = async (): Promise<any> =>
  APIManager.sendGet(EnterpriseEnds.GET_TOKEN_LIST, true, {}, {}, axios);

const deleteToken = async (id: string): Promise<any> =>
  APIManager.sendDelete(EnterpriseEnds.DELETE_TOKEN(id), true, {}, {}, axios);

export const EnterpriseService = {
  getEnterpriseToken,
  getTokenList,
  deleteToken,
};
